const FIELDS = [
  { prop: "firstName", label: "First Name" },
  { prop: "lastName", label: "Last Name" },
  { prop: "dateOfBirth", label: "Date of Birth" },
  { prop: "gender", label: "Gender" },
];

export default FIELDS;
